import { EventType } from '../../../../../services/Event/types'
import { GeneralFieldsEditor } from '../GeneralFieldsEditor'
import { SeriesForm } from './eventSeriesFormShared'

interface IProps {
  form: SeriesForm
  patchSeries: (patch: Partial<SeriesForm>) => void
  fieldErrors: Record<string, string[]>
  saving: boolean
  eventTypes: EventType[]
  activeCampaignLists: { id: string; name: string }[]
}

export function LocationTab({ form, patchSeries, fieldErrors, saving, eventTypes, activeCampaignLists }: IProps) {
  return (
    <GeneralFieldsEditor
      value={form}
      onChange={patchSeries}
      groups={['location']}
      eventTypes={eventTypes}
      activeCampaignLists={activeCampaignLists}
      formatForLocation={form.format}
      disabled={saving}
      errors={fieldErrors}
    />
  )
}
